var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"row d-lg-flex align-items-center mt-4"},[_c('div',{staticClass:"col-lg-12"},[_c('PoweredBy',{attrs:{"url":_vm.url}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }